module.exports = __webpack_public_path__ + "static/media/amex.a9eddb34.svg";